import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Form from "react-validation/build/form";
import { FormControl} from '@mui/base/FormControl';
import { Input} from '@mui/base/Input';
import { Button } from '@mui/base/Button';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import logo from './../assets/UNAVIO-LOGO-BLACK.png'
import LoginBG from './../assets/pfedelbachpost5-korrektur2-Kopie.jpg'

import AuthService from "../services/auth.service";


const ForgotPassword = () => {
  const delay = ms => new Promise(res => setTimeout(res, ms));

  const [username, setUsername] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const onChangeUsername = (e) => {
    const username = e.target.value;
    setUsername(username);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    let result = await AuthService.forgotPassword(username);
    setMessage(result.data.message);
  };

  function Copyright(props) {
    return (
      <Typography variant="body2" color="text.secondary" align="center" {...props}>
        {'Copyright © '}
        <Link color="inherit" href="https://unavio.de/">
          UNAVIO GmbH
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    );
  }

  return(
    <Grid container component="main" sx={{ height: '100vh' }}>
      <Grid item xs={false} sm={4} md={7} sx={{
          backgroundImage: `url(${LoginBG})`,
          backgroundRepeat: 'no-repeat',
          backgroundColor: (t) =>
            t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6}>
          <Box sx={{ mt: -9 ,display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
            <Box sx={{ textAlign: 'center'}}>
              <img 
                src={logo} 
                alt="Unavio Logo" 
                style={{ 
                  maxWidth: '250px',    // Maximalbreite einstellen
                  height: 'auto',       // Proportionale Höhe
                  display: 'block',     // Zentriert
                  margin: '0 auto'      // Zentrierung sicherstellen
                }} 
              />
              <h2 style={{marginTop: "40px"}}>Passwort vergessen?</h2>
            </Box>
            <Form onSubmit={handleLogin}>
              <Grid container spacing={2} my={4}>
                <Grid item xs={12}>
                  <FormControl required className='wb-input-wrapper'>
                    <label>E-Mail</label>
                    <Input  type="text" name="username" onChange={onChangeUsername}/>
                  </FormControl>
                </Grid>
                <Grid item xs={12} >
                    <Box sx={{ textAlign: 'center'}}>
                        {message && (
                            <div className="form-group">
                            <div className="alert alert-info" role="alert">
                                {message}
                            </div>
                            </div>
                        )}
                        <Button type="submit" className='btn prim' >Passwort zurücksetzen</Button>
                    </Box>
                </Grid>
              </Grid>
            </Form>
            <Copyright />
          </Box>
        </Grid>
      </Grid>
  );
};

export default ForgotPassword;